import React from 'react';

const ListExamIcon = () => (
  <svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 0.75C15.5 0.336 15.164 0 14.75 0H0.75C0.336 0 0 0.336 0 0.75V18.75C0 19.164 0.336 19.5 0.75 19.5H14.75C15.164 19.5 15.5 19.164 15.5 18.75V0.75ZM1.5 1.5V18H14V1.5H1.5Z"
      fill="#303A48"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 5.5H9.75C10.164 5.5 10.5 5.164 10.5 4.75C10.5 4.336 10.164 4 9.75 4H5.75C5.336 4 5 4.336 5 4.75C5 5.164 5.336 5.5 5.75 5.5Z"
      fill="#303A48"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21094 10.334H12.5489C12.9629 10.334 13.2989 9.99798 13.2989 9.58398C13.2989 9.16998 12.9629 8.83398 12.5489 8.83398H8.21094C7.79694 8.83398 7.46094 9.16998 7.46094 9.58398C7.46094 9.99798 7.79694 10.334 8.21094 10.334Z"
      fill="#303A48"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21094 14.666H12.5489C12.9629 14.666 13.2989 14.33 13.2989 13.916C13.2989 13.502 12.9629 13.166 12.5489 13.166H8.21094C7.79694 13.166 7.46094 13.502 7.46094 13.916C7.46094 14.33 7.79694 14.666 8.21094 14.666Z"
      fill="#303A48"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.60706 9.3452L4.66906 8.2322C4.95506 7.9332 5.43006 7.9222 5.72906 8.2072C6.02906 8.4932 6.04006 8.9682 5.75406 9.2682L4.16206 10.9352C4.02306 11.0812 3.83106 11.1652 3.62906 11.1672C3.42706 11.1702 3.23306 11.0912 3.09006 10.9482L2.42106 10.2812C2.12806 9.9892 2.12706 9.5142 2.41906 9.2212C2.71206 8.9272 3.18706 8.9272 3.48006 9.2192L3.60706 9.3452Z"
      fill="#303A48"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.60706 13.6781L4.66906 12.5651C4.95506 12.2661 5.43006 12.2541 5.72906 12.5401C6.02906 12.8261 6.04006 13.3011 5.75406 13.6011L4.16206 15.2681C4.02306 15.4141 3.83106 15.4971 3.62906 15.5001C3.42706 15.5021 3.23306 15.4241 3.09006 15.2811L2.42106 14.6141C2.12806 14.3221 2.12706 13.8461 2.41906 13.5531C2.71206 13.2601 3.18706 13.2591 3.48006 13.5521L3.60706 13.6781Z"
      fill="#303A48"
    />
  </svg>
);

export default ListExamIcon;
